
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property-contact",
      function () {
        return require("private-next-pages/property-contact.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/property-contact"])
      });
    }
  